import { render, staticRenderFns } from "./RgpHome.vue?vue&type=template&id=1669c7e2&scoped=true&"
import script from "./RgpHome.vue?vue&type=script&lang=js&"
export * from "./RgpHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1669c7e2",
  null
  
)

export default component.exports